import { gql } from '@apollo/client';
import { getClient } from '../apollo';
import { AuthType } from '../generated/graphql';

const USER_LOGIN = gql`
  mutation UserLogin($data: UserLoginInput!) {
    userLogin(data: $data) {
      token
      user {
        _id
        email
        firstName
        lastName
        artistName
        image
      }
    }
  }
`;

const USER_CREATE = gql`
  mutation UserCreate($data: UserCreateInput!) {
    userCreate(data: $data) {
      token
      user {
        _id
        email
        firstName
        lastName
        artistName
        image
      }
    }
  }
`;

const USER_OAUTH = gql`
  mutation UserOAuth($data: UserOAuthInput!) {
    userOAuth(data: $data) {
      token
      user {
        _id
        email
        firstName
        lastName
        artistName
        image
      }
    }
  }
`;

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterCredentials {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  artistName: string;
}

export interface OAuthCredentials {
  email: string;
  provider: string;
  providerAccountId: string;
  profile: {
    given_name?: string;
    family_name?: string;
    name?: string;
    picture?: string;
    avatar_url?: string;
  };
  accessToken?: string;
  refreshToken?: string;
  expiresAt?: number;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthType> {
    const client = getClient();
    const { data } = await client.mutate({
      mutation: USER_LOGIN,
      variables: {
        data: credentials,
      },
    });

    if (!data?.userLogin) {
      throw new Error('Login failed');
    }

    return data.userLogin;
  },

  async register(credentials: RegisterCredentials): Promise<AuthType> {
    const client = getClient();
    const { data } = await client.mutate({
      mutation: USER_CREATE,
      variables: {
        data: credentials,
      },
    });

    if (!data?.userCreate) {
      throw new Error('Registration failed');
    }

    return data.userCreate;
  },

  async oauthLogin(credentials: OAuthCredentials): Promise<AuthType> {
    const client = getClient();
    const { data } = await client.mutate({
      mutation: USER_OAUTH,
      variables: {
        data: credentials,
      },
    });

    if (!data?.userOAuth) {
      throw new Error('OAuth login failed');
    }

    return data.userOAuth;
  },
};
